import React from 'react';
import cx from 'classnames';

import withStyles from '@mui/styles/withStyles';

import referralAssocGroupStyles from '../assets/jss/crm/components/referralAssocGroupStyles';

import ReferralSummary from './ReferralSummary';

class ReferralCategoryGroup extends React.Component {
  render() {
    const { classes, label, referrals } = this.props;

    if (referrals.length === 0) {
      return null;
    }

    return (
      <div>
        <div className={classes.entitySummaryCategory_title}>{label}</div>
        <div className={cx(classes.entitySummary, classes.entitySummary_contact)}>
          <div className={cx(classes.entitySummary_title, classes.u_ellipsis, classes.ac_h4)}>
            {referrals.map((referral) => (
              <ReferralSummary key={referral.referralId} referral={referral} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(referralAssocGroupStyles)(ReferralCategoryGroup);
